import React from 'react';
import { ErrorFlag } from '@atlassian/jira-flags'; // ignore-for-ENGHEALTH-17759
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Props = {
	id: string | number;
	onDismissed: (id: number | string) => void;
};

export function CardDragDisallowedFlag({ id, onDismissed }: Props) {
	const { formatMessage } = useIntl();

	return (
		<ErrorFlag
			id={id}
			onDismissed={onDismissed}
			title={formatMessage(messages.removeSubtaskTitle)}
			description={formatMessage(messages.removeSubtaskDescription)}
		/>
	);
}
